import { api } from './client';

export type BackendHarvestStatus =
  | 'EXPECTED'
  | 'FARMER_UPDATED'
  | 'PENDING_HTX_CONFIRM'
  | 'HTX_CONFIRMED'
  | 'LOW_YIELD'
  | 'COMPLETED'
  | 'CANCELLED';

export type BackendHarvestQuality = 'GOOD' | 'AVERAGE' | 'POOR';

export interface BackendHarvestUpdateLogEntry {
  at: string;
  by: string;
  note: string;
}

export interface BackendHarvest {
  _id: string;
  code?: string;
  farmerId: string;
  fieldId?: string;
  seasonId?: string;
  contractId?: string;
  mainCrop: string;
  productType: string;
  expectedQuantity: number;
  actualQuantity?: number;
  actualQuantityConfirmed: boolean;
  unit: string;
  expectedDate: string;
  harvestedDate?: string;
  status: BackendHarvestStatus;
  estimatedPriceVnd: number;
  quality?: BackendHarvestQuality;
  qualityNote?: string;
  notes?: string;
  warning?: string;
  attachmentFileIds: string[];
  updateLog: BackendHarvestUpdateLogEntry[];
  isDeleted: boolean;
}

export interface CreateHarvestPayload {
  farmerId: string;
  fieldId?: string;
  seasonId?: string;
  contractId?: string;
  mainCrop: string;
  productType: string;
  expectedQuantity: number;
  unit: string;
  expectedDate: string;
  estimatedPriceVnd: number;
  notes?: string;
}

export async function createHarvest(data: CreateHarvestPayload): Promise<BackendHarvest> {
  return api.post<BackendHarvest>('/harvests', data);
}

export interface ReportActualHarvestPayload {
  actualQuantity: number;
  harvestedDate?: string;
  attachmentFileIds?: string[];
  notes?: string;
}

export async function reportActualHarvest(id: string, data: ReportActualHarvestPayload): Promise<BackendHarvest> {
  return api.post<BackendHarvest>(`/harvests/${id}/report-actual`, data);
}

export interface ConfirmHarvestPayload {
  quality?: BackendHarvestQuality;
  qualityNote?: string;
}

export async function confirmHarvest(id: string, data?: ConfirmHarvestPayload): Promise<BackendHarvest> {
  return api.post<BackendHarvest>(`/harvests/${id}/confirm`, data);
}

export async function completeHarvest(id: string): Promise<BackendHarvest> {
  return api.post<BackendHarvest>(`/harvests/${id}/complete`);
}

export async function cancelHarvest(id: string, reason: string): Promise<BackendHarvest> {
  return api.post<BackendHarvest>(`/harvests/${id}/cancel`, { reason });
}

export async function getHarvestById(id: string): Promise<BackendHarvest> {
  return api.get<BackendHarvest>(`/harvests/${id}`);
}

export async function listHarvestsByFarmer(farmerId: string): Promise<BackendHarvest[]> {
  return api.get<BackendHarvest[]>(`/harvests/farmers/${farmerId}`);
}

export async function listHarvestsByHtx(htxId: string): Promise<BackendHarvest[]> {
  return api.get<BackendHarvest[]>(`/harvests/htx/${htxId}`);
}
